export const UPDATE_PURPOSES = {
  PRODUCT_SWITCH: 'I am performing a product switch',
  SPLIT: 'I am editing after a split',
  UPDATE_FIELDS: 'I am updating fields changed elsewhere',
};
